// extracted by mini-css-extract-plugin
export default {"heading":"Blog_heading__WRR6g","container":"Blog_container__3ZM2x","section":"Blog_section__hEoS8","section2":"Blog_section2__n0E+A","h1":"Blog_h1__1Bwvi","para":"Blog_para__ro6o7"};